// The account-form body shared by the profile-edit / change-password /
// address create-update documents: the legacy oscar/partials/form.html
// structure (CSRF + field tree + submit + history-back cancel) inside the
// .account-form wrapper, with the form rendered as a native React field tree.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import {
    FORM_CLASS_NAME,
    FORM_FIELD_CLASS_NAME,
    FORM_FIELD_SUBMIT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

// ProfileUpdateDocumentTemplate, ChangePasswordDocumentTemplate, and
// AddressFormDocumentTemplate generate identical field shapes; index one of
// them for the complex field types.
type ITemplate = templates.ProfileUpdateDocumentTemplate;

type IProps = Immutable<{
    form_id: string;
    action_url: string;
    fields: ITemplate["fields"];
    field_labels: ITemplate["field_labels"];
    field_errors: ITemplate["field_errors"];
    non_field_errors: ITemplate["non_field_errors"];
    submit_text: string;
    cancel_text: string;
}>;

export const AccountForm = (props: IProps): React.JSX.Element => (
    <div className="account-form">
        <form
            id={props.form_id}
            className={FORM_CLASS_NAME}
            method="post"
            action={props.action_url}
        >
            <CSRFToken />
            <FormFields
                fields={props.fields}
                field_labels={props.field_labels}
                field_errors={props.field_errors}
                non_field_errors={props.non_field_errors}
                showRequiredLegend
            />
            <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                <input
                    type="submit"
                    className="button button--full-width"
                    value={props.submit_text}
                />
            </div>
            <div className={FORM_FIELD_CLASS_NAME}>
                <a
                    className="button button--secondary button--full-width"
                    onClick={() => getWindow()?.history.go(-1)}
                >
                    {props.cancel_text}
                </a>
            </div>
        </form>
    </div>
);
